import React, {useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';

import {validateLoginLink} from 'src/openapi/admin/apis/LoginLinkApi';
import {useAppDispatch} from 'src/store/hooks';

import Loading from '@pb/kit-component-loading';

export const LoginLinkHandler: React.FC = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!token) {
            window.location.href = '/';
            return;
        }

        const validateToken = async () => {
            const result = await dispatch(validateLoginLink({validateLoginLinkRequest: {token}}));

            if (result.payload.success) {
                window.location.href = result.payload.data.redirectUrl;
            } else {
                window.location.href = '/';
            }
        };

        validateToken();
    }, [token, dispatch]);

    return <Loading fast={true}/>;
};
